import * as React from 'react';
import {imageBaseUrl} from 'utils/config';
import 'DialogBox/styles.scss';

interface IDialogProps {
  status: boolean;
}

const DialogBox = ({status}: IDialogProps) => {
  return (
    <div className="payment-dialog-container">
      <div className="payment-dialog">
        <img className="check-mark" src={`${imageBaseUrl}/img/${status ? 'green-check.gif': 'red-cross.gif'}`} alt="Payment Status"/>
        <h1 className={`payment-heading ${status ? 'success': 'fail'}`}>{status ? 'Payment Successful!': "Something's Wrong"}</h1>
        {!status && <p className="error-message"><span>The transaction couldn't complete.</span><span>Please Try Again or contact support</span></p>}
      </div>
    </div>
  );
};

DialogBox.defaultProps = {
  status: true
}
export default DialogBox;